define('lib/pager/Pager',['require','marionette'],function (require) {
    var Marionette = require('marionette');

    return Marionette.Object.extend({

        _page: 1,
        _onPage: 10,
        _pagesCount: 0,
        _data: null,
        _filter: null,
        _skipPagination: 0, //NB to avoid sending 'false' as string and comparing it to true as boolean on server

        initialize: function () {
            this._data = this.getOption('data') || {};
            this._filter = this.getOption('filter') || {};
        },

        getPage: function () {
            return this._page;
        },

        setFilter: function (name, value) {
            this._filter[name] = value;

            this.trigger('change');
            this.trigger('update:info');
        },

        getFilter: function (name) {
            if (this._filter[name]) {
                return this._filter[name];
            }
            return null;
        },

        getFilters: function () {
            return this._filter;
        },

        setState: function (page, pagesCount, itemsCount) {
            this._page = parseInt(page);
            this._pagesCount = parseInt(pagesCount);
            this._itemsCount = parseInt(itemsCount);

            this.trigger('update:info');
        },

        setPage: function (page) {
            this._page = parseInt(page);

            this.trigger('change');
            this.trigger('update:info');

            return this;
        },

        getOnPage: function () {
            return this._onPage;
        },

        setOnPage: function (onPage) {
            this._onPage = parseInt(onPage);

            this.trigger('change');
            this.trigger('update:info');

            return this;
        },

        getPagesCount: function () {
            return this._pagesCount;
        },

        setPagesCount: function (pagesCount) {
            this._pagesCount = parseInt(pagesCount);

            this.trigger('update:info');

            return this;
        },

        getItemsCount: function () {
            return this._itemsCount;
        },

        setItemsCount: function (itemsCount) {
            this._itemsCount = parseInt(itemsCount);

            this.trigger('update:info');

            return this;
        },

        setSkipPagination: function (flag) {
            this._skipPagination = flag ? 1 : 0;

            return this;
        },

        getSkipPagination: function () {
            return this._skipPagination;
        },

        getData: function () {
            var result = {
                'page': this.getPage(),
                'on_page': this.getOnPage(),
                'pages_count': this.getPagesCount(),
                'skip_pagination': this.getSkipPagination(),
                'filter': this.getFilters(),

                first_item: (this.getPage() - 1) * this.getOnPage() + 1,
                last_item: Math.min(this.getPage() * this.getOnPage(), this.getItemsCount()),
                total_items: this.getItemsCount()
            };
            return _.extend(result, this._data);
        }

    });
});
